// PIXI.js checks the first line of the vertex shader for a #version declaration

// To load a shadertoy shader need to apply the header (version, precision, out, uniforms)
// rewrite mainImage function to main signature
// TODO: add a main function on the bottom that calls mainImage

{ Filter } from "pixi.js"

{ CUSTOM_PRESET_NAME } from ../const.civet

vendored from ./shaders-vendored.civet
originals from ./shaders-original.civet

export shaderToyShaders := [{
  name: "Purple"
  themeKey: "light"
}, {
  // Self authored
  name: "Starleidoscope"
  id: "ftt3R7"
  themeKey: "dark"
}, {
  // Written for this app — see shaders-original.civet. No API fetch, no licence to
  // honour, and beat-locked through iBeat rather than inferred from FFT peaks.
  name: "Beat Bloom"
  id: "orig-beat-bloom"
  themeKey: "dark"
}, {
  name: "Spectrum Rain"
  id: "orig-spectrum-rain"
  themeKey: "dark"
}, {
  // Compositing helper, not a look: flat keying green behind the dark-theme UI.
  name: "Chroma Key"
  id: "orig-chroma-key"
  themeKey: "dark"
}, {
  name: "Waveform Ribbon"
  id: "orig-waveform-ribbon"
  themeKey: "dark"
}, {
  name: "Neon Horizon"
  id: "orig-neon-horizon"
  themeKey: "dark"
}, {
  name: "Spectrum Skyline"
  id: "orig-spectrum-skyline"
  themeKey: "dark"
}, {
  name: "Chrome Tunnel"
  id: "orig-chrome-tunnel"
  themeKey: "dark"
}, {
  // Neon Horizon variations
  name: "Neon Storm"
  id: "orig-neon-storm"
  themeKey: "dark"
}, {
  // The one pale scheme in the set — a light staff over a light floor is unreadable, so
  // this is the light theme rather than dark.
  name: "Neon Daybreak"
  id: "orig-neon-daybreak"
  themeKey: "light"
}, {
  name: "Neon Ocean"
  id: "orig-neon-ocean"
  themeKey: "dark"
}, {
  name: "Neon Ridgeline"
  id: "orig-neon-ridgeline"
  themeKey: "dark"
}, {
  name: "Vapor Checker"
  id: "orig-vapor-checker"
  themeKey: "dark"
}, {
  name: "Neon Corridor"
  id: "orig-neon-corridor"
  themeKey: "dark"
}, {
  name: "Amber CRT"
  id: "orig-amber-crt"
  themeKey: "dark"
}, {
  // The quiet set: dark and flat behind the staff, motion only at the frame's edges.
  name: "Quiet Meters"
  id: "orig-quiet-meters"
  themeKey: "dark"
}, {
  name: "Still Stars"
  id: "orig-still-stars"
  themeKey: "dark"
}, {
  name: "Quiet Scope"
  id: "orig-quiet-scope"
  themeKey: "dark"
}, {
  name: "Quiet Spectrum"
  id: "orig-quiet-spectrum"
  themeKey: "dark"
}, {
  name: "Dusk Steps"
  id: "orig-dusk-steps"
  themeKey: "dark"
}, {
  // Synthwave Sunset https://www.shadertoy.com/view/tsScRK (unknown)
  name: "Synthwave Sunset"
  id: "tsScRK"
  themeKey: "dark"
}, {
  // Cyber Fuji 2020 https://www.shadertoy.com/view/Wt33Wf (unknown)
  name: "Cyber Fuji 2020"
  id: "Wt33Wf"
  themeKey: "dark"
}, {
  // https://www.shadertoy.com/view/lscczl (CC-NC-SA)
  name: "The Universe Within"
  id: "lscczl"
  themeKey: "dark"
}, {
  // Phantom Star https://www.shadertoy.com/view/ttKGDt (unknown)
  name: "Phantom Star"
  id: "ttKGDt"
  themeKey: "dark"
}, {
  // Octagrams https://www.shadertoy.com/view/tlVGDt (unknown)
  name: "Octograms"
  id: "tlVGDt"
  themeKey: "dark"
}, {
  // Warp Speed 2 https://www.shadertoy.com/view/4tjSDt (CC-NC-SA)
  name: "Warp Speed 2"
  id: "4tjSDt"
  themeKey: "dark"
}, {
  // Pinku https://www.shadertoy.com/view/ftSSRR (unknown)
  name: "Pinku"
  id: "ftSSRR"
  themeKey: "dark"
}]

defaultPreset := shaderToyShaders[0]

// Circuits https://www.shadertoy.com/view/XlX3Rj

// Cool Shaders
// ---

// Dearly Departed https://www.shadertoy.com/view/4ls3D4
// City Skyline https://www.shadertoy.com/view/MlX3DM
// 2d Clouds https://www.shadertoy.com/view/4tdSWr
// 002 Blue https://www.shadertoy.com/view/WldSRn
// Pretty Hip https://www.shadertoy.com/view/XsBfRW
// Fragment Plane https://www.shadertoy.com/view/MsfXRf
// Hot and Cold Crustacean https://www.shadertoy.com/view/ltXyzS
// Palace of Mind https://www.shadertoy.com/view/wttXDl
// Timeless Depths https://www.shadertoy.com/view/ts3yD7
// Ashanoha https://www.shadertoy.com/view/wlGGWG
// PsychedelicSakura https://www.shadertoy.com/view/wlGXRD
// Husky https://www.shadertoy.com/view/WsG3Ry
// Sakura Fubuki https://www.shadertoy.com/view/3l3SzM
// Metal Vortex https://www.shadertoy.com/view/wssXzr
// Squishy Donut Cat https://www.shadertoy.com/view/WlBBzV
// Kaleidoscope Tunnel https://www.shadertoy.com/view/WsSGWG
// Simplicity https://www.shadertoy.com/view/lslGWr
// Parallax Galaxy https://www.shadertoy.com/view/7sSXDW
// Fireworks https://www.shadertoy.com/view/wttfzN
// Red Landscape https://www.shadertoy.com/view/NsS3Dt
// svfwarp https://www.shadertoy.com/view/3dS3zV
// Lone Planet https://www.shadertoy.com/view/7s2GR3
// Rainbow Truchet https://www.shadertoy.com/view/3dcGWM
// Ikeda Data Stream https://www.shadertoy.com/view/slfSR7
// Creation https://www.shadertoy.com/view/XsXXDn
// Cineshader Test https://www.shadertoy.com/view/wlVGWd
// Tiny Planet https://www.shadertoy.com/view/7dKXWR
// Lava Lamp https://www.shadertoy.com/view/fsKXDm
// Ancient Ocean of Terror https://www.shadertoy.com/view/ssVSzG
// Alien Miner Energy Blob https://www.shadertoy.com/view/NsKSRy
// Glacial Valleys https://www.shadertoy.com/view/NdKXWm
// Simple Terrain https://www.shadertoy.com/view/3dXcW2
// Eroded Mountain Terrain https://www.shadertoy.com/view/fts3Wl
// Dolphins at Sea https://www.shadertoy.com/view/ssGSzy
// Oblivion Radar https://www.shadertoy.com/view/4s2SRt
// Universal Flow https://www.shadertoy.com/view/sscXD7
// Tileable Water Caustic https://www.shadertoy.com/view/MdlXz8
// Galaxy of Universes https://www.shadertoy.com/view/MdXSzS
// Ribbon Assault https://www.shadertoy.com/view/MdBGDK
// Moon Light https://www.shadertoy.com/view/fsyXDD
// Flame https://www.shadertoy.com/view/MdX3zr
// Colorblinds https://www.shadertoy.com/view/ssGXWD
// FBM (salt-stained-blue-gold) https://www.shadertoy.com/view/7sVXWD
// 41/49 https://www.shadertoy.com/view/NdVXDD
// Mandala Playground https://www.shadertoy.com/view/tlfXR8
// Liberation of the True Self https://www.shadertoy.com/view/tlGfzd
// Grass Scene #1 https://www.shadertoy.com/view/7stSzf
// Lady Bugs in the Meadow https://www.shadertoy.com/view/fsdXWj
// Fractal Land https://www.shadertoy.com/view/XsBXWt
// Generators https://www.shadertoy.com/view/Xtf3Rn
// Sound Grid https://www.shadertoy.com/view/XlBXRh
// Shimmy https://www.shadertoy.com/view/fd2GD1
// Warp Speed https://www.shadertoy.com/view/Msl3WH (unknown)

// API Busted
// ---

// Protean Clouds https://www.shadertoy.com/view/3l23Rh (CC-NC-SA)
// Neon Dance https://www.shadertoy.com/view/7sX3WN (unknown)
// Circuits https://www.shadertoy.com/view/XlX3Rj (MIT)

// More Shaders
// ---
// Fractal Pulse https://www.shadertoy.com/view/MlsfR4

// Educational Resources
// ---
// Glowering Sun (multi-buffer post processing) https://www.shadertoy.com/view/7sGGWd
// Phantom Mode https://www.shadertoy.com/view/MtScWW
// Sponge Tunnel https://www.shadertoy.com/view/ttK3Wt
// Perlin Noise Fire https://www.shadertoy.com/view/3tcBzH
// http://www.fractalforums.com/new-theories-and-research/very-simple-formula-for-fractal-patterns/
// https://iquilezles.org/www/articles/derivative/derivative.htm
// Vornoi overlaps https://www.shadertoy.com/view/4tj3zW
// Micro Shader Demo 2 https://www.shadertoy.com/view/fdySWh
// https://www.shadertoy.com/user/Kali
// https://www.iquilezles.org/www/articles/distfunctions/distfunctions.htm
// Ray Marching Tutorial https://www.shadertoy.com/view/XllGW4

vertex := """
#version 300 es
precision highp float;
#define SHADER_NAME vfx-vertex

in vec2 aVertexPosition;
out vec2 vTextureCoord;

uniform mat3 projectionMatrix;
uniform vec4 inputSize;
uniform vec4 outputFrame;

vec4 filterVertexPosition( void ) {
    vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;
    return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);
}

vec2 filterTextureCoord( void ) {
    return aVertexPosition * (outputFrame.zw * inputSize.zw);
}

void main(void) {
    gl_Position = filterVertexPosition();
    vTextureCoord = filterTextureCoord();
}

"""

phantom := """
precision highp float;

mat2 rot(float a) {
    float c = cos(a), s = sin(a);
    return mat2(c,s,-s,c);
}

const float pi = acos(-1.0);
const float pi2 = pi*2.0;

vec2 pmod(vec2 p, float r) {
    float a = atan(p.x, p.y) + pi/r;
    float n = pi2 / r;
    a = floor(a/n)*n;
    return p*rot(-a);
}

float box( vec3 p, vec3 b ) {
    vec3 d = abs(p) - b;
    return min(max(d.x,max(d.y,d.z)),0.0) + length(max(d,0.0));
}

float ifsBox(vec3 p) {
    for (int i=0; i<5; i++) {
        p = abs(p) - 1.0;
        p.xy *= rot(iTime*0.3);
        p.xz *= rot(iTime*0.1);
    }
    p.xz *= rot(iTime);
    return box(p, vec3(0.4,0.8,0.3));
}

float map(vec3 p, vec3 cPos) {
    vec3 p1 = p;
    p1.x = mod(p1.x-5., 10.) - 5.;
    p1.y = mod(p1.y-5., 10.) - 5.;
    p1.z = mod(p1.z, 16.)-8.;
    p1.xy = pmod(p1.xy, 5.0);
    return ifsBox(p1);
}

void mainImage( out vec4 fragColor, in vec2 fragCoord ) {
    vec2 p = (fragCoord.xy * 2.0 - iResolution.xy) / min(iResolution.x, iResolution.y);

    float F = smoothstep(0.0, 1.0, texture(iChannel0, vec2(0.25, 0.)).x);

    vec3 cPos = vec3(0.0,0.0, -3.0 * iTime);
    // vec3 cPos = vec3(0.3*sin(iTime*0.8), 0.4*cos(iTime*0.3), -6.0 * iTime);
    vec3 cDir = normalize(vec3(0.0, 0.0, -1.0));
    vec3 cUp  = vec3(sin(iTime), 1.0, 0.0);
    vec3 cSide = cross(cDir, cUp);

    vec3 ray = normalize(cSide * p.x + cUp * p.y + cDir);

    // Phantom Mode https://www.shadertoy.com/view/MtScWW by aiekick
    float acc = 0.0;
    float acc2 = 0.0;
    float t = 0.0;
    for (int i = 0; i < 99; i++) {
        vec3 pos = cPos + ray * t;
        float dist = map(pos, cPos);
        dist = max(abs(dist), 0.02);
        float a = exp(-dist*3.0);
        if (mod(length(pos)+24.0*F, 30.0) < 3.0) {
            a *= 2.0;
            acc2 += a;
        }
        acc += a;
        t += dist * 0.5;
    }

    vec3 col = vec3(acc * 0.01, acc * 0.011 + acc2*0.002, acc * 0.012+ acc2*0.005);
    fragColor = vec4(col, 1.0 - t * 0.03);
}
"""

example := """
// Create your own shader using GLSL Shader Language!
void mainImage( out vec4 fragColor, in vec2 fragCoord)
{
    vec2 uv = fragCoord/iResolution.xy;

    float dy = 0.5 / iResolution.y;
    // xy is LR Frequency domain data
    vec2 fv = texture(iChannel0, vec2(uv.x, 0.)).xy;
    // zw is LR Time domain data
    vec2 tv = texture(iChannel0, vec2(uv.x, 0.)).zw;
    vec3 col = vec3(0.);

    // Time domain data
    if (!(uv.y + dy < tv.x) && (uv.y - dy < tv.x)) {
        // Color the pixel that crosses the time domain sample value
        col += 1.;
    }

    // Frequency domain data
    if (uv.y < fv.x) {
        col.gb += fv.x + 0.2;
    }

    fragColor = vec4(col,1.0);
}

"""

fragmentHeader := """
#version 300 es
precision highp float;

out vec4 fragColor;

uniform float iBeat; // Quarter note position in song
uniform vec3 iResolution; // width, height, pixel density — in DEVICE pixels, same units
                          // as gl_FragCoord, so uv = fragCoord/iResolution.xy is 0..1
// 1 when the frame is being drawn into a render texture rather than onto the canvas,
// which is the opposite way up. gl_FragCoord.y counts from the bottom of whichever
// framebuffer is bound, so without this the shader mirrors vertically while the sprites
// (transformed by the projection, not by gl_FragCoord) stay the right way up.
uniform float iFlipY;
uniform float iSampleRate; // Audio sample rate
uniform float iGlobalTime;
uniform float iTimeDelta;
uniform float iTime; // time position in song in seconds
uniform float iFrame;
uniform vec4 iMouse;
uniform sampler2D iChannel0;
uniform sampler2D iChannel1;
uniform sampler2D iChannel2;

// Length of the loop being rendered, in seconds and in quarter notes. Both are 0 during
// ordinary playback, which does not come back around.
uniform float iLoopTime;
uniform float iLoopBeats;

/**
Snap an animation rate so the term it drives comes back to its starting phase exactly at
the loop point.

`cyclesPerSecond` is in whatever units the term is periodic in — cells per second for a
scrolling grid, noise cells per second for a drifting field. The returned rate is the
nearest one that fits a whole number of those cycles into a loop, so at iTime == iLoopTime
the phase has advanced by an integer and the frame matches iTime == 0.

Below one cycle per loop it rounds to a single cycle rather than to zero: rounding to zero
would freeze the term, which is a worse artefact than a slow drift running slightly fast.
Outside a loop it is the identity, so live playback keeps the authored rate.
*/
float loopRate(float cyclesPerSecond) {
  if (iLoopTime <= 0.0) { return cyclesPerSecond; }
  return sign(cyclesPerSecond) * max(1.0, round(abs(cyclesPerSecond) * iLoopTime)) / iLoopTime;
}

/**
The scroll offset itself, for a term read through fract() or floor(), which is what you
want over `t * loopRate(rate)` wherever the pattern has hard edges.

Two things beyond loopRate. It never leaves one period, so it does not lose precision: a
40s loop at 1.6 cells/s hands floor() a value around 64, where a float has about 4e-6 of
resolution, and every pixel that lands that close to a cell boundary picks the neighbouring
cell instead. On a soft-edged grid that is a hairline nobody sees; on the filled squares of
a checkerboard it is a line of squares in the wrong colour on the seam frame.

And it is exactly 0 at the loop point rather than a whole number of cells along, because
`period` is built into the count instead of being left to the caller. Patterns that repeat
every two cells — anything alternating — come back inverted otherwise.
*/
float loopPhase(float cyclesPerSecond, float t, float period) {
  if (iLoopTime <= 0.0) { return cyclesPerSecond * t; }
  // Whole periods per loop, at least one so the term never freezes.
  float cycles = max(1.0, round(cyclesPerSecond * iLoopTime / period)) * period;
  return mod(cycles * (t / iLoopTime), period);
}

/** loopPhase for the usual case of a pattern that repeats every cell. */
float loopPhase(float cyclesPerSecond, float t) {
  return loopPhase(cyclesPerSecond, t, 1.0);
}

/**
The same, for a sin() or cos() argument, whose period is 2*pi rather than 1. Pass the rate
in radians per second and use the result the same way.
*/
float loopRateAngular(float radiansPerSecond) {
  return 6.2831853071795865 * loopRate(radiansPerSecond / 6.2831853071795865);
}

/** The same, for a term driven by iBeat rather than iTime. */
float loopRateBeats(float cyclesPerBeat) {
  if (iLoopBeats <= 0.0) { return cyclesPerBeat; }
  return sign(cyclesPerBeat) * max(1.0, round(abs(cyclesPerBeat) * iLoopBeats)) / iLoopBeats;
}

/**
A drift that ends where it started, for scrolling an offset into a noise field.

loopRate is enough for anything sampled through fract(), because that is periodic already
and only the rate has to be made to fit. A noise field is not: it never repeats, so a
linear traversal of it has nothing to come back to and no choice of speed makes one loop.

So instead of travelling in a straight line this walks a circle — same starting direction,
same constant speed, same distance covered per loop, but closed. The field still drifts at
the authored rate; it just curves so gently over the loop that the return is not visible,
which a straight line could only manage by tiling the noise (and then the tile is).

Anything derived from the result stays periodic, including scaling it for another octave,
because scaling a periodic function leaves it periodic. Outside a loop this is the plain
linear drift.
*/
vec2 loopDrift(vec2 velocity, float t) {
  float speed = length(velocity);
  if (iLoopTime <= 0.0 || speed <= 0.0) { return velocity * t; }
  vec2 fwd = velocity / speed;
  vec2 side = vec2(-fwd.y, fwd.x);
  // Circumference = speed * iLoopTime, so the loop covers the distance the straight line
  // would have. p(0) is the origin and p'(0) is the velocity, so nothing about the opening
  // frame or its motion changes.
  float radius = speed * iLoopTime / 6.2831853071795865;
  float ph = 6.2831853071795865 * t / iLoopTime;
  return radius * (fwd * sin(ph) + side * (1.0 - cos(ph)));
}

/**
Wrap a cell index so a hashed lattice repeats once per loop.

loopRate is not enough on its own for anything keyed on floor(): it brings the coordinate
back to the same position WITHIN a cell, but after a whole number of cells, and a hash of
the cell index gives that cell its own value. Scrolling rain that has advanced 440 cells is
in phase and made of different drops.

`cellsPerLoop` is how many cells the term advances in one loop — rate * iLoopTime, a whole
number by construction if the rate came from loopRate. Wrapping the index by it makes the
hash field itself periodic, at a period far longer than anything on screen at once, so the
repeat is invisible except at the seam, where it is the point.

Outside a loop the index still has to be wrapped, just by something arbitrary. A hash of a
cell index is only as good as the sin() inside it, and these hashes scale the index by ~289
before taking one: an hour into a song a scrolling lattice is 40,000 cells along, the
argument is past 1e7, and the result stops varying from cell to cell — the drops thin out
and then disappear entirely rather than degrading visibly. 1024 keeps the argument near 3e5,
where it is exact, and repeats far too slowly to be seen.
*/
float loopCell(float cell, float cellsPerLoop) {
  if (iLoopTime <= 0.0 || cellsPerLoop < 1.0) { return mod(cell, 1024.0); }
  return mod(cell, round(cellsPerLoop));
}

"""

fragmentFooter := """
void main()
{
  vec2 fragCoord = vec2(gl_FragCoord.x, mix(gl_FragCoord.y, iResolution.y - gl_FragCoord.y, iFlipY));
  mainImage(fragColor, fragCoord);
  fragColor = vec4(fragColor.rgb, 1.0);
}
"""

uniforms :=
  iResolution: [500, 500, 1]
  iFlipY: 0
  iLoopTime: 0
  iLoopBeats: 0
  iGlobalTime: 0
  iTimeDelta: 0
  iFrame: 0
  iMouse: [250, 250, 250, 250]
  iTime: 10

wrap := (code: string) ->
  ```
  ${fragmentHeader}
  ${code}
  ${fragmentFooter}
  ```

fetchFromShadertoy := (id: string) ->
  if id is "ttKGDt"
    return Promise.resolve(wrap(phantom))

  // Written in-repo: no fetch, no key, no attribution burden. Checked by
  // scripts/shadertoy/check-shaders.mjs, which compiles them through this same wrapper.
  if originals[id]
    return Promise.resolve(wrap(originals[id].code))

  // Vendored source never touches the network, which sidesteps all three ways the live
  // fetch fails silently: the 1500/month API quota, the Cloudflare bot challenge (a
  // headless render is exactly the profile it blocks), and shaders whose visibility is
  // "Public" rather than "Public + API" and so are simply not served.
  // Add one with: node scripts/shadertoy/vendor-shaders.mjs <id>
  if vendored[id]
    return Promise.resolve(wrap(vendored[id].code))

  // TODO: Caching
  fetch(`https://www.shadertoy.com/api/v1/shaders/${id}?key=NdrK4D`)
  .then (r) ->
    // `r.ok?` tests that the property exists, which it always does — so an error page
    // used to flow into r.json() and reject with a parse error instead of this message.
    if r.ok
      r.json()
    else
      throw new Error `Failed to fetch shader ${id} from shadertoy.com`
  .then ({Error:error, Shader}) ->
    if error
      throw new Error error

    // Pass order is not guaranteed to put the image pass first: a shader with a Common
    // tab hands back the shared helper block at index 0, which compiles as nonsense.
    imagePass := Shader.renderpass.find (p: {type: string}) -> p.type is "image"
    unless imagePass
      throw new Error `Shader ${id} has no image renderpass`

    wrap(imagePass.code)


defaultFragment := wrap """
  void mainImage(out vec4 fragColor, in vec2 fragCoord) {
    vec2 uv = fragCoord / iResolution.xy;
    fragColor.rgb = vec3(0.92, 0.905, 0.965);
  }
"""

loadingFilter := new Filter(vertex, defaultFragment, uniforms)

//@ts-ignore
shaderToyShaders[0].filter = false

customPreset :=
  name: CUSTOM_PRESET_NAME
  id: CUSTOM_PRESET_NAME
  themeKey:
    showMeasureNumbers: false
    staffAlpha: 0
    staffBgColor: 0xffffff
    lyricsColor: 0x202020
    minimapVisible: false
    playheadHeight: 0
  // TODO: make sure to load this in when MIDI loads also
  filter: undefined as Filter? // this gets filled in with the real filter from the live editor
  // Resolves when `filter` is the real one rather than the loading placeholder.
  loading: undefined as Promise<void>?

loadFilter := (preset: typeof customPreset) ->
  {id} := preset

  if preset.filter?
    return preset.loading
  else
    preset.filter = loadingFilter

    // Kept on the preset so a caller can wait for it. Until the fetch lands, `filter` is
    // loadingFilter, which paints flat lavender — fine for a frame or two on screen,
    // wrong in a video, where those frames are permanent and sit at the loop point.
    preset.loading = fetchFromShadertoy id
    .then (fragmentShader) ->
      preset.filter = new Filter(vertex, fragmentShader, uniforms)
      return

    return preset.loading

/**
The presets the on-screen picker offers.

The 13 in-repo originals (the "orig-*" ids, see shaders-original.civet) render correctly
but have no picker thumbnail on the CDN yet — composer/fx/shaders/orig-*.jpg all 404, so
FXPicker would draw them as blank buttons. They stay in shaderToyShaders because the daily
shorts select them by name through app/render-cli.js, which validates against
Player#vfxPresetNames. Drop this filter once the thumbnails are uploaded.
*/
export pickerShaders := shaderToyShaders.filter (preset) ->
  //@ts-ignore — only the shadertoy and original presets carry an id
  not preset.id?.startsWith "orig-"

export Shaders :=
  example: example
  vertex: vertex
  uniforms: uniforms
  shaderToyShaders: shaderToyShaders
  fetchFromShadertoy: fetchFromShadertoy

  // Sets the current custom preset code
  setCustomPreset: (code: string) ->
    customPreset.filter = new Filter vertex, wrap(code), uniforms

// Lookup and load shadertoy preset by name
/**
Resolve once the named preset's shader is compiled and ready to draw.

An offline render has to wait for this. On screen a frame or two of the loading placeholder
is invisible; in a 40s short those frames are the first thing a viewer sees, every time it
loops.
*/
export presetLoaded := (presetName: string): Promise<unknown> ->
  preset := presetByName presetName
  //@ts-ignore — only the shadertoy presets carry a load promise
  preset.loading ?? Promise.resolve()

export presetByName := (presetName: string) ->
  if presetName is CUSTOM_PRESET_NAME
    return customPreset

  preset := shaderToyShaders.find ({name}) -> name is presetName

  if preset
    //@ts-ignore
    loadFilter(preset)

  return preset or defaultPreset

export default Shaders
